module.exports = __webpack_public_path__ + "static/media/menu_logo_branca.790e073a.png";